import {
	type MutateZeroQueriesMutationVariables,
	type QuickFindZeroQueriesQueryVariables,
	zeroQueriesMutation,
	zeroQueriesQuery,
	type ZeroQuery,
} from '@atlassian/search-client';

export const fetchZeroQueries = async (variables: QuickFindZeroQueriesQueryVariables) =>
	await zeroQueriesQuery({ variables }).then((response) => {
		const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
		const shuffledZeroQueries = [...zeroQueries].sort(() => Math.random() - 0.5);
		return shuffledZeroQueries.map(mapEssentialData);
	});

export const mapEssentialData = (zeroQuery: ZeroQuery) => ({
	id: zeroQuery.query,
	title: zeroQuery.query,
	data: zeroQuery.query,
	product: zeroQuery.product,
	accountId: zeroQuery.accountId,
	avatarUrl: zeroQuery.avatarUrl,
	dateRange: zeroQuery.dateRange,
	type: 'zero-query' as const,
	zeroQueryType: zeroQuery.type,
});

export const mutateZeroQueries = async (variables: MutateZeroQueriesMutationVariables) =>
	await zeroQueriesMutation({ variables }).then(
		(response) => response.data?.knowledgeDiscovery.markZeroQueryInteracted.success,
	);
